import { Route } from '@angular/router'
import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { UserDetailComponent } from './user-detail.component'

export const userRoutes: Route[] = [
  // Users.
  {
    path: 'users/myself',
    component: UserDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'readOwnUsers',
    }
  },
]
